import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  .title-bar {
    height: 20px;
  }
`;
